import React, { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { Dialog, DialogTitle, DialogContent, Button } from "@mui/material/";
import { Add } from "@mui/icons-material";
import { strings } from "../../../common/i18n";
import { enums } from "../../../common/lib";
import { AuditAssignmentsAddDialog } from "../../../common/components";
import MatReactTable from "../../../common/components/MaterialReactTable";
import useColumnsRows from "./useColumnsRows";

type Props = {
    loading: boolean
};

/**
 * Edit Audit Assignments Component
 */

export default ({ loading }: Props) => {
    const { audits } = useSelector((state) => state);
    const { columns, data, loadingTable, initialState } = useColumnsRows();
    const [dialogOpen, setDialogOpen] = useState(false);

    const addDisabled = useMemo(() => {
        if (!loading && audits.item && audits.item.status) {
            const { id } = audits.item.status;
            return !(
                id === enums.status.audit.awaitingDownload ||
                id === enums.status.audit.partiallyCompleteCount ||
                id === enums.status.audit.pendingCount
            );
        }
        return true;
    }, [audits, loading]);

    const onDialogClose = () => setDialogOpen(false);
    const onDialogOpen = () => setDialogOpen(true);
    if (loadingTable) return <>Still loading..</>;

    const toolBarComponents = () => (
        <Button
            variant="outlined"
            size="small"
            startIcon={<Add />}
            onClick={onDialogOpen}
            disabled={addDisabled}
        >
            {strings("addAuditAssignments")}
        </Button>
    );

    return (
        <>
            <MatReactTable
                persistKey="auditEditAssignments"
                loading={data.length < 1 || loadingTable}
                columns={columns}
                data={data}
                noRowsMessage={strings("messages.noAuditors")}
                toolBarComponents={toolBarComponents}
                initialState={initialState}
            />
            <Dialog onClose={onDialogClose} open={dialogOpen}>
                <DialogTitle>{strings("addAuditAssignments")}</DialogTitle>
                <DialogContent>
                    <AuditAssignmentsAddDialog
                        open={dialogOpen}
                        onClose={onDialogClose}
                        onSaveComplete={onDialogClose}
                        type="Assignment"
                    />
                </DialogContent>
            </Dialog>
        </>
    );
};
